module.exports = __webpack_public_path__ + "img/Malaysian.cbadc77d.svg";